// The optimal size of the batching mechanism is determined by the number of features that need to be updated in the map per frame. (tested for large datasets)
export const OPTIMAL_SIZE_OF_UPDATING_BATCHING = 500;
export const OPTIMAL_SIZE_OF_REMOVING_BATCHING = 1500;

// For zoom levels below this value, the roads volumes are not displayed and calculated.
export const MIN_ZOOM_FOR_ROADS_VOLUMES = 9;
